export enum EventType {
  SHOW_OVERLAY = 'show_overlay',
  HIDE_OVERLAY = 'hide_overlay'
}
